export const resetPassword = {
    title: '비밀번호 재설정',
    newPassword: '새 비밀번호',
    confirmNewPassword: '새 비밀번호 입력',
    resetSuccess: '비밀번호 재설정은 성공하였습니다.',
    buttonSave: '저장',
};
